export default __webpack_public_path__ + "./assets/Alison__7ec614cd64357084e085a96fdadf8a8c.png";